import { axiosInstance } from "@/lib/axios-instance";

export interface DocSendImportParams {
  url: string;
  email: string;
  passcode?: string;
  company_id: string;
  opportunity_id?: string;
  file_type?: string;
}

export interface DocSendImportResponse {
  status: string;
  message: string;
  file: {
    _id: string;
    file_name: string;
    file_type: string;
    file_url: string;
    file_size: string;
    upload_source: string;
  };
}

export interface DocSendValidateResponse {
  status: string;
  documentId?: string;
  message: string;
}

export const docsendApi = {
  /**
   * Import a file from DocSend
   */
  importFile: async (params: DocSendImportParams): Promise<DocSendImportResponse> => {
    const response = await axiosInstance.post("/docsend/import-file", params);
    return response.data;
  },

  /**
   * Validate a DocSend URL without importing
   */
  validateUrl: async (url: string): Promise<DocSendValidateResponse> => {
    const response = await axiosInstance.get("/docsend/validate-url", {
      params: { url },
    });
    return response.data;
  },
};
